import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import ruRU from 'antd/locale/ru_RU';
import 'antd/dist/reset.css';
import { store } from './store';
import Layout from './components/Layout/layout';
import AppRoutes from './routes/app-routes';
import './index.css';

const App = () => {
  return (
      <Provider store={store}>
        <ConfigProvider
            locale={ruRU}
            theme={{
              token: {
                colorPrimary: '#FF6B35',
                colorSuccess: '#52c41a',
                colorWarning: '#faad14',
                colorError: '#ff4d4f',
                colorInfo: '#1890ff',
                borderRadius: 12,
                fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
              },
              components: {
                Button: {
                  borderRadius: 8,
                  controlHeight: 40,
                },
                Card: {
                  borderRadius: 16,
                },
                Input: {
                  borderRadius: 8,
                },
              },
            }}
        >
          <Router>
            <Layout>
              <AppRoutes />
            </Layout>
          </Router>
        </ConfigProvider>
      </Provider>
  );
};

export default App;